import { useQuoteCopy } from "../i18n/QuoteCopyContext";
import type { SubmitErrorKind } from "../types";
import { ContactCard } from "./ContactCard";
import { AlertIcon } from "./icons";

interface Props {
  errorKind?: SubmitErrorKind;
  submitting: boolean;
  onBackToEdit: () => void;
  onRetry: () => void;
}

export function ResultError({
  errorKind,
  submitting,
  onBackToEdit,
  onRetry,
}: Props) {
  const copy = useQuoteCopy();
  return (
    <section className="card" aria-labelledby="nv-result-title">
      <div className="nv-card-scroll">
      <div className="nv-result-head">
        <span className="nv-result-icon error" aria-hidden="true">
          <AlertIcon size={26} />
        </span>
        <div>
          <h2 className="nv-result-title" id="nv-result-title" data-step-heading tabIndex={-1}>
            {copy.t("result.sendFailed")}
          </h2>
          <p className="nv-result-sub" role="alert">
            {copy.submitError(errorKind ?? "network")}
          </p>
        </div>
      </div>

      <div className="nv-result-body">
        <ContactCard title={copy.t("result.preferDirect")} />
      </div>
      </div>

      <div className="confirm-actions">
        <button type="button" className="btn-secondary" onClick={onBackToEdit} disabled={submitting}>
          {copy.t("result.backToEdit")}
        </button>
        <button type="button" className="btn-primary" onClick={onRetry} disabled={submitting}>
          {submitting ? (
            <>
              <span className="nv-spinner" />
              {copy.t("nav.sending")}
            </>
          ) : (
            copy.t("result.tryAgain")
          )}
        </button>
      </div>
    </section>
  );
}
